// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "tr td[data-v-5b7b8732]:last-of-type{padding-left:.5em;text-align:right;white-space:nowrap}td[data-v-5b7b8732]{position:relative;vertical-align:middle}.free[data-v-5b7b8732]{background:#fff;border:1px solid var(--colour-text-light);border-radius:.45em;color:var(--colour-dark-blue);display:inline-flex;font-size:var(--small);font-weight:600;padding:.05em .4em .1em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
